// src/config.js
// 개인 IP 주소
// export const BROKER_IP = "http://localhost:3001/";
// BORA TEST
// export const BROKER_IP = "http://112.216.36.126:3001/";
// PACKAGE TEST
// export const BROKER_IP = "http://112.216.36.126:3006/";
// PACKAGE CUST TEST
// export const BROKER_IP = "http://112.216.36.126:4001/";
// export const BROKER_IP = "http://localhost:4001/";


// DHL 서버
// BORA
// export const BROKER_IP = "http://222.231.28.236:3001/";
// PACKAGE
// export const BROKER_IP = "http://222.231.28.236:3006/";
// PACKAGE CUST
// export const BROKER_IP = "http://222.231.28.236:3010/";
export const BROKER_IP = "http://222.231.25.114:4001/";